import request from '@/Utilities/httpRequest';
//import {isEmpty} from 'lodash-es';
//import apiCheckout from '@/api/checkout';

export default {
    baseUrl: null,

    setBaseUrl (url) {
        if(url && url.length > 0){
            const curLocation = window.location;
            const base = curLocation.protocol+'//'+curLocation.hostname;
            if(curLocation.port == '8080' && url.indexOf(':8080/') !== -1){
                // this is development env running in local mode
                console.log('this is development env running in local mode');
                url = process.env.VUE_APP_DEV_STORE;
            }
            const oUrl = new URL(url, base);
            const path = oUrl.pathname.split("/");

            this.baseUrl = oUrl.origin + "/" + path[1] + "/" + path[2];
        }
    },

    getUrl (controllerAction) {
        //console.log('get URL for ', controllerAction)
        if(this.baseUrl === null) {
            //console.log('set base URL from ', window.location.href);
            // parse base URL from current location
            this.setBaseUrl(window.location.href);
        }
        let url = this.baseUrl;
        if(typeof controllerAction !== 'undefined'){
            url = url + "/" + controllerAction;
        }
        return url;
    },

    // async actionRequest(url, params) {
    //     // in test
    //     const response = await request.get(url, params, false);
    //     let responseError = response.data.hasError;
    //     let responseMsg = response.data.msg ? response.data.msg : null;
    //     let result = null;
    //     //console.log('action request:', response);
    //     try {
    //         if (!responseError) {
    //             result = response.data.result;
    //         } else {
    //             console.log('action request failed: ', responseMsg);
    //         }

    //     } catch (error) {
    //         console.log('action request error!: ', error);
    //     }

    //     return result;
    // },

    async getComboById(id) {
        const params = {
            id: id,
        };

        const {data} = await request.get(this.getUrl('combo/by-group-id'), params, false);
        if(data && data.hasOwnProperty('combos') && data.combos){
            return data.combos.filter(elm => elm.products.length == 2);
        }
        return null;
    },

    async getBlackRabbitComboById(id, blocksColor, limit) {
        const params = {
            id: id,
            blocksColor: blocksColor,
            limit: limit ?? 3
        };

        const {data} = await request.get(this.getUrl('combo/get-block-struct'), params, false);
        return data??null;
    },

    async loadProdInfo(id) {
        const params = {
            id: id,
        };

        const {data} = await request.get(this.getUrl('combo/get-product-info'), params, false);
        return data ? data : null;
    },

    // async loadCombos(listIds) {
    //     const params = {
    //         list: listIds,
    //     };

    //     const {data} = await request.get(this.getUrl('product/combos'), params, false);
    //     return data ? data : null;
    // },
       
};
